module.exports = __webpack_public_path__ + "static/media/minus.38e2bb57.svg";